<script>
import Layout from "@/router/layouts/main";
import { mapState } from "vuex";
import { api } from "@/state/services";
import { required } from "vuelidate/lib/validators";

export default {
  locales: {
    pt: {
    },
    es: {
    }
  },
  components: {
    Layout,
  },
  computed: {
    ...mapState({
      account: state => state.account
    }),
  },
  data() {
    return {
      dependents: null,

      create: {
        modal: false,
        loading: false,
        user: {
          name: "",
          cpf: "",
          gender: "",
          birthday: "",
          email: "",
          cellphone: "",
          password: "",
        }
      },

      edit: {
        modal: false,
        loading: false,
        user: {
          id: "",
          name: "",
          cpf: "",
          gender: "",
          birthday: "",
          email: "",
          cellphone: "",
        }
      }
    };
  },
  validations: {
    create: {
      user: {
        name: { required },
        cpf: { required },
        gender: { required },
        birthday: { required },
        email: { required },
        cellphone: { required },
        password: { required },
      }
    },
    edit: {
      user: {
        name: { required },
        gender: { required },
        birthday: { required },
        email: { required },
        cellphone: { required },
      }
    }
  },
  methods: {
    getDependents() {
      this.dependents = null;

      api
        .get('dependents')
        .then((response) => {
          if (response.data.status == 'success') {
            this.dependents = response.data.list;
          }
        })
    },
    showCreate() {
      this.create.modal = false;
      this.create.modal = true;
    },
    createDependent() {
      this.$v.$touch();

      this.create.loading = true;

      api
        .post('dependents', {
          name: this.create.user.name,
          cpf: this.create.user.cpf,
          gender: this.create.user.gender,
          birthday: this.create.user.birthday,
          email: this.create.user.email,
          cellphone: this.create.user.cellphone,
          password: this.create.user.password,
        })
        .then((response) => {
          if (response.data.status == 'success') {
            this.create.user.name = "";
            this.create.user.cpf = "";
            this.create.user.gender = "";
            this.create.user.birthday = "";
            this.create.user.email = "";
            this.create.user.cellphone = "";
            this.create.user.password = "";

            this.create.modal = false;
            this.create.loading = false;

            this.$toast.success("O dependente foi cadastrado com sucesso.");
            this.getDependents();
          } else {
            this.create.loading = false;
            this.$toast.error(response.data.message);
          }
        })
        .catch((error) => {
          if (error) {
            this.create.modal = false;
            this.create.loading = false;
          }
        })
        .finally(() => {
        });
    },
    showEdit(user) {
      this.edit.modal = false;
      this.edit.modal = true;
      this.edit.loading = false;
      this.edit.user = user;
    },
    closeEdit() {
      this.edit.modal = false;
      this.edit.loading = false;
    },
    editDependent() {
      this.$v.$touch();

      this.edit.loading = true;

      api
        .post('dependents/' + this.edit.user.id, {
          name: this.edit.user.name,
          gender: this.edit.user.gender,
          birthday: this.edit.user.birthday,
          email: this.edit.user.email,
          cellphone: this.edit.user.cellphone,
        })
        .then((response) => {
          if (response.data.status == 'success') {
            this.edit.user.id = "";
            this.edit.user.name = "";
            this.edit.user.cpf = "";
            this.edit.user.gender = "";
            this.edit.user.birthday = "";
            this.edit.user.email = "";
            this.edit.user.cellphone = "";

            this.edit.modal = false;
            this.edit.loading = false;

            this.$toast.success("O dependente foi editado com sucesso.");
            this.getDependents();
          } else {
            this.edit.loading = false;
            this.$toast.error(response.data.message);
          }
        })
        .catch((error) => {
          if (error) {
            this.edit.modal = false;
            this.edit.loading = false;
          }
        })
        .finally(() => {
        });
    },
  },
  mounted() {
    this.getDependents();
  }
};
</script>

<template>
  <Layout>
    <div class="page-title-box d-md-flex justify-content-between mb-3">
      <div>
        <h3>Meus Dependentes</h3>
        <p>Acompanhe e gerencie os cadastros dos seus dependentes.</p>
      </div>
    </div>

    <button class="btn border btn-lg btn-block mb-4" v-on:click="showCreate()">
      Adicionar dependente
    </button>

    <div v-if="!dependents" class="text-center">
      <b-spinner variant="default" role="status"></b-spinner>
    </div>

    <div v-else-if="dependents && dependents.length == 0" class="card">
      <div class="card-body text-center">
        Nenhum dependente cadastrado.
      </div>
    </div>

    <div v-else>
      <button class="mb-2 p-0 border-0 bg-transparent w-100 text-left" v-for="(row, index) in dependents" :key="index" v-on:click="showEdit(row);">
        <div class="card mb-0">
          <div class="card-body d-flex justify-content-between align-items-center">
            <div>
              <img v-if="account.user.avatar" class="rounded-circle header-profile-user" :src="account.user.avatar" alt="" />
              <img v-else class="rounded-circle header-profile-user" :src="'https://ui-avatars.com/api/?background=3275FF&color=fff&name=' + account.user.name" alt="" />
            </div>
            <div class="ml-3 w-75">
              <h5 class="m-0 text-dark font-size-16"><strong>{{ row.name }}</strong></h5>
              <p class="m-0 text-dark text-uppercase">{{ row.birthday }}</p>
            </div>
            <div class="ml-3">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(50, 47, 79, 1);">
                <path d="M10.707 17.707 16.414 12l-5.707-5.707-1.414 1.414L13.586 12l-4.293 4.293z"></path>
              </svg>
            </div>
          </div>
        </div>
      </button>
    </div>

    <b-modal v-model="create.modal" modal-class="modal-right" hide-header hide-footer>
      <b-form @submit.prevent="createDependent">
        <h4>Adicionar novo dependente</h4>
        <p></p>
        <div class="my-5">
          <b-form-group label="Nome" label-for="name">
            <b-form-input id="name" v-model="create.user.name" type="text" required></b-form-input>
          </b-form-group>
          <b-form-group label="CPF" label-for="cpf">
            <b-form-input id="cpf" v-model="create.user.cpf" type="text" required v-mask="'###.###.###-##'" inputmode="numeric"></b-form-input>
          </b-form-group>
          <b-form-group label="Sexo" label-for="gender">
            <select v-model="create.user.gender" class="custom-select" required>
              <option value="male">Masculino</option>
              <option value="female">Feminino</option>
            </select>
          </b-form-group>
          <b-form-group label="Data de Nascimento" label-for="birthday">
            <b-form-input id="birthday" v-model="create.user.birthday" type="text" required v-mask="'##/##/####'" inputmode="numeric"></b-form-input>
          </b-form-group>
          <b-form-group label="E-mail" label-for="email">
            <b-form-input id="email" v-model="create.user.email" type="email" required inputmode="email"></b-form-input>
          </b-form-group>
          <b-form-group label="Celular" label-for="cellphone">
            <b-form-input id="cellphone" v-model="create.user.cellphone" type="text" required v-mask="'(##) #####-####'" inputmode="numeric"></b-form-input>
          </b-form-group>
          <b-form-group label="Senha" label-for="password">
            <b-form-input id="password" v-model="create.user.password" type="password" required></b-form-input>
          </b-form-group>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <button class="btn btn-default btn-lg mr-3" type="submit" :disabled="this.create.loading">
            Adicionar
            <b-spinner v-if="create.loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
          </button>
          <a class="btn btn-outline-link" v-on:click="create.modal = false">Fechar</a>
        </div>
      </b-form>
    </b-modal>

    <b-modal v-model="edit.modal" modal-class="modal-right" hide-header hide-footer>
      <b-form @submit.prevent="editDependent">
        <h4>Editar dependente</h4>
        <p></p>
        <div class="my-5">
          <b-form-group label="Nome" label-for="name">
            <b-form-input id="name" v-model="edit.user.name" type="text" required></b-form-input>
          </b-form-group>
          <b-form-group label="CPF" label-for="cpf">
            <b-form-input id="cpf" class="bg-soft-primary" v-model="edit.user.cpf" type="text" disabled></b-form-input>
          </b-form-group>
          <b-form-group label="Sexo" label-for="gender">
            <select v-model="edit.user.gender" class="custom-select" required>
              <option value="">–</option>
              <option value="male">Masculino</option>
              <option value="female">Feminino</option>
            </select>
          </b-form-group>
          <b-form-group label="Data de Nascimento" label-for="birthday">
            <b-form-input id="birthday" v-model="edit.user.birthday" type="text" required v-mask="'##/##/####'" inputmode="numeric"></b-form-input>
          </b-form-group>
          <b-form-group label="E-mail" label-for="email">
            <b-form-input id="email" v-model="edit.user.email" type="email" required inputmode="email"></b-form-input>
          </b-form-group>
          <b-form-group label="Celular" label-for="cellphone">
            <b-form-input id="cellphone" v-model="edit.user.cellphone" type="text" required v-mask="'(##) #####-####'" inputmode="numeric"></b-form-input>
          </b-form-group>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <button class="btn btn-default btn-lg mr-3" type="submit" :disabled="this.edit.loading">
            Salvar
            <b-spinner v-if="edit.loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
          </button>
          <a class="btn btn-outline-link" v-on:click="closeEdit();">Fechar</a>
        </div>
      </b-form>
    </b-modal>
  </Layout>
</template>